import React, { useMemo, useState } from 'react';
import { Formik, Form } from 'formik';
import { post } from 'axios';
import PropTypes from 'prop-types';

import FilledButton from 'components/Buttons/FilledButton';
import ModalContiner from 'components/ModalContainer';

import { renderToast } from 'components/Informations/Toast/utils';

import endpoints from 'services/endpoints';

import * as S from '../styles';
import * as Yup from 'yup';

const { insertBlock } = endpoints;

export default function ModalSSBlock({ data, open, setOpen, type }) {
  const { id_area, id_funcionario: idFuncionario, observer } = data;

  const [toastVisibility, setToastVisibility] = useState(false);
  const [toastInfos, setToastInfos] = useState({
    type: '',
    message: '',
    autoClose: 6000,
  });

  const initialValues = useMemo(() => {
    return {
      nome: data.nome,
      descricao: data.descricao,
    };
  }, [data]);

  const schema = useMemo(() => {
    return Yup.object().shape({
      nome: Yup.string()
        .min(3, 'O nome deve conter no mínimo 3 caractéres')
        .required('Campo obrigatório'),
      descricao: Yup.string().max(255, 'Limite de caractéres excedido'),
    });
  }, []);

  const handleSubmit = (values, { resetForm }) => {
    const objectToSend = {
      id_area,
      id_usr_in: idFuncionario,
      nome: values.nome,
      descricao: values.descricao,
    };

    return post(insertBlock, objectToSend)
      .then(() => {
        setToastVisibility(true);
        setToastInfos({
          type: 'success',
          message: 'Bloco inserido com sucesso',
          autoClose: 6000,
        });
      })
      .then(() => {
        setTimeout(() => {
          resetForm();
          observer();
          setOpen(false);
        }, 4000);
      })
      .catch(() => {
        setToastVisibility(true);
        setToastInfos({
          type: 'error',
          message: 'Erro ao remover bloco',
          autoClose: 6000,
        });
      });
  };

  return (
    <>
      {toastVisibility &&
        renderToast(
          toastInfos.type,
          toastInfos.message,
          toastInfos.autoClose,
          setToastVisibility
        )}

      <ModalContiner
        isOpen={open}
        setIsOpen={setOpen}
        headText={'Adicionar novo bloco'}
      >
        <Formik
          initialValues={initialValues}
          validationSchema={schema}
          onSubmit={handleSubmit}
        >
          {({ values, errors, setFieldValue, resetForm }) => (
            <Form>
              <S.FormField
                label="Nome do bloco"
                label_for="nome_bloco"
                error={!!errors?.nome}
                error_message={errors?.nome}
              >
                <S.FormInput
                  value={values.nome}
                  name="nome"
                  id="nome_bloco"
                  onChange={e => setFieldValue('nome', e.target.value)}
                  error={!!errors?.nome}
                />
              </S.FormField>

              <S.FormField
                label="Descrição"
                label_for="desc_bloco"
                error={!!errors?.descricao}
                error_message={errors?.descricao}
              >
                <S.TextField
                  value={values.descricao}
                  name="descricao"
                  id="desc_bloco"
                  onChange={e => setFieldValue('descricao', e.target.value)}
                  error={!!errors?.descricao}
                />
              </S.FormField>

              <S.ButtonsWrap>
                <FilledButton
                  text="Cancelar"
                  buttonClass="cancel"
                  handleClick={e => {
                    e.preventDefault();
                    resetForm();
                    setOpen(false);
                  }}
                />
                <FilledButton
                  text="enviar"
                  buttonType="submit"
                  buttonClass="confirm"
                />
              </S.ButtonsWrap>
            </Form>
          )}
        </Formik>
      </ModalContiner>
    </>
  );
}

ModalSSBlock.defaultProps = {
  type: 'add',
  data: {
    nome: '',
    descricao: '',
  },
};
ModalSSBlock.propTypes = {
  data: PropTypes.shape({
    id_area: PropTypes.number.isRequired,
  }),
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  type: PropTypes.string,
};
